export enum DocumentCollection {
    Stories = 'stories',
    Chapters = 'chapters',
    Articles = 'product',
    Artworks = 'artworks',
    Comments = 'comments',
    TokensFcm = 'fcmTokens'
}